import { jsx as _jsx } from "react/jsx-runtime";
import { amazonMarketDomains, walmartMarketDomains } from "@helium10/re-core";
import styled from "styled-components";
import { FlagAustralia, FlagBelgium, FlagBrazil, FlagCanada, FlagChina, FlagEgypt, FlagFrance, FlagGermany, FlagIndia, FlagItaly, FlagJapan, FlagMexico, FlagNetherlands, FlagPoland, FlagSaudiArabia, FlagSingapore, FlagSpain, FlagSweden, FlagTurkey, FlagUnitedArabEmirates, FlagUnitedKingdom, FlagUnitedStates, } from "../../icon/components";
export const flagsMarketplaceRelation = {
    "amazon.co.uk": _jsx(FlagUnitedKingdom, {}),
    "amazon.com.au": _jsx(FlagAustralia, {}),
    "amazon.com.mx": _jsx(FlagMexico, {}),
    "amazon.ca": _jsx(FlagCanada, {}),
    "amazon.com": _jsx(FlagUnitedStates, {}),
    "amazon.de": _jsx(FlagGermany, {}),
    "amazon.es": _jsx(FlagSpain, {}),
    "amazon.fr": _jsx(FlagFrance, {}),
    "amazon.in": _jsx(FlagIndia, {}),
    "amazon.it": _jsx(FlagItaly, {}),
    "amazon.nl": _jsx(FlagNetherlands, {}),
    "amazon.co.jp": _jsx(FlagJapan, {}),
    "amazon.com.br": _jsx(FlagBrazil, {}),
    "amazon.com.tr": _jsx(FlagTurkey, {}),
    "amazon.cn": _jsx(FlagChina, {}),
    "amazon.sg": _jsx(FlagSingapore, {}),
    "amazon.ae": _jsx(FlagUnitedArabEmirates, {}),
    "amazon.sa": _jsx(FlagSaudiArabia, {}),
    "amazon.se": _jsx(FlagSweden, {}),
    "amazon.pl": _jsx(FlagPoland, {}),
    "amazon.eg": _jsx(FlagEgypt, {}),
    "amazon.com.be": _jsx(FlagBelgium, {}),
    "walmart.com": _jsx(FlagUnitedStates, {}),
};
export const FlagLabel = styled.div `
  font-size: 27px;
  width: 27px;
  display: flex;
  align-items: center;
`;
export const amazonOptions = amazonMarketDomains.map((value) => ({ value, label: `www.${value}`, group: "amazonGroup" }));
export const walmartOptions = walmartMarketDomains.map((value) => ({ value, label: `www.${value}`, group: "walmartGroup" }));
export const allMarketsOptions = [...amazonOptions, ...walmartOptions];
